import { z } from 'zod';
import { lighthouseDNSOffHostSchema, lighthouseDNSOnHostSchema } from '#schemas/config-override/lighthouse-dns-host.ts';
import { lighthouseDNSOffPortSchema, lighthouseDNSOnPortSchema } from '#schemas/config-override/lighthouse-dns-port.ts';

export const lighthouseServeDNSOnSchema = z.object({
  host: lighthouseDNSOnHostSchema,
  port: lighthouseDNSOnPortSchema,
});

export const lighthouseServeDNSOffSchema = z.object({
  host: lighthouseDNSOffHostSchema,
  port: lighthouseDNSOffPortSchema,
});
